import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_backoffice/about/')({
  component: RouteComponent
})

function RouteComponent() {
  return <div>Hello "/_backoffice/about/"!</div>
}
